import ContactInner from "../components/ContactInner";
import FooterThree from "../components/FooterThree";
import HeaderThree from "../components/HeaderThree";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const ContactPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderThree />

      {/* ContactInner */}
      <ContactInner />
      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default ContactPage;
